let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8U52D"), load("bEOWq"), load("5K06i"), load("c6MKV"), load("jjWia")]).then(() => parcelRequire('c8BWz'));